import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import toast, { Toaster } from "react-hot-toast";
import { departmentKeyValue1, getWarehouseKeyValueList } from "../../../services/index";
import AddIcon from "@mui/icons-material/Add";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { getDepStockClosingList, getDepStockClosingRecordDetails, getStockClosingList, getStockClosingRecordDetails, logDepStockClosingHistory, logStockClosingHistory } from "../../../services/Inventory/OtherServices";
import { sortLatestFirst } from "../../utils/textUtils";
import Select from "react-select";
import { Table } from "react-bootstrap";

const DepartmentStockClosingView = () => {
    let { uuid, id } = useParams();
    const [filteredList, setFilteredList] = useState([]);
    const [list, setList] = useState([]);
    const [recordDetails, setRecordDetails] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [wareOptions, setWareOptions] = useState(null);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState({
        value: "",
        label: "Select Warehouse",
    });
    const [selectedDepartment, setSelectedDepartment] = useState({
        value: "",
        label: "Select Department",
    })
    const [selectedDepartmentOptions, setSelectedDepartmentOptions] = useState(null)
    const [logData, setLogData] = useState({});

    useEffect(() => {
        setTabIndex(0);
    }, [id]);

    useEffect(() => {
        if (tabIndex === 1 && id) {
            logDepStockClosingHistory(id).then((res) => {
                if (res.errorCode === 0) {
                    const d = res.responsePacket;
                    setLogData(d);
                } else {
                    toast(res.message);
                }
            });
        }

    }, [tabIndex]);
    useEffect(() => {
        getRecordDetails(uuid, id);
    }, [])

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                let options = [];
                res.responsePacket?.map((d) => {
                    options.push({
                        value: d.key,
                        label: d.value,
                    });
                });
                setSelectedWarehouse(options[0])
                setWareOptions(options);
            } else {
                toast(res.message);
            }
        });
        departmentKeyValue1().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setSelectedDepartmentOptions(options)
                if (selectedDepartment.value == "") {
                    setSelectedDepartment(options[0])
                }
            }
        })
    }, [uuid]);

    useEffect(() => {
        if (selectedDepartment?.value && selectedWarehouse?.value) {
            getDepStockClosingList(selectedWarehouse.value, selectedDepartment.value).then((res) => {
                if (res.errorCode === 0) {
                    let temp = sortLatestFirst(res.responsePacket, "createdAt");
                    setList(temp);
                    setFilteredList(temp);
                    setLoading(null);
                } else {
                    toast.error(res.message);
                    setLoading(null);
                }
            });
        }

    }, [selectedDepartment, selectedWarehouse])

    const getRecordDetails = (uuid, id) => {
        getDepStockClosingRecordDetails(uuid, id).then((res) => {
            if (res.errorCode === 0) {
                setRecordDetails(res.responsePacket);
            } else {
                toast.error(res.message);
            }
        });
    };

    useEffect(() => {
        if (list && filteredList) {
            const result = list.filter((data) => {
                return data.code.toLowerCase().includes(search.toLowerCase()) || data.createdAt.toLowerCase().includes(search.toLowerCase());
            });
            setFilteredList(result);
        }
    }, [search]);

    const handleSelectWarehouse = (e) => {
        setSelectedWarehouse(e);
        // getList(e.value);
        setSearch("");
    };
    const handleSelectDepartement = (e) => {
        setSelectedDepartment(e);
    };


    return (
        <>
            <div className="list-column column d-print-none" style={{ width: "300px" }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="input-group paginationSearchInput listSearch">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1">
                                <SearchRoundedIcon />
                            </span>
                        </div>
                        <input autoComplete="off" className="form-control" type="text" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
                    </div>
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <div className="listFilterAndSearch">
                            <Link to="/departmentstockClosing/new" className="newListBtn">
                                <AddIcon />
                            </Link>
                            <div className="listFilter">
                                <Select value={selectedWarehouse} options={wareOptions} onChange={handleSelectWarehouse} />
                            </div>
                            <div className="listFilter">
                                <Select value={selectedDepartment} isDisabled={!selectedDepartmentOptions} options={selectedDepartmentOptions} onChange={(e) => handleSelectDepartement(e)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="scroll-y fill body scrollbox list-body" style={{ marginTop: "45px" }}>
                    <div className="table-responsive overflow-initial">
                        {loading === "list" ? (
                            <div className="text-center ">Loading...</div>
                        ) : (
                            <table id="ember7912" className="table zi-table table-hover ember-view header-fixed">
                                <tbody>
                                    {filteredList &&
                                        (filteredList.length > 0 ? (
                                            filteredList.map((row, i) => (
                                                <tr
                                                    key={i}
                                                    onClick={() => {
                                                        setTabIndex(0);
                                                        getRecordDetails(row?.uuid, row?.code);
                                                    }}
                                                    className={`listTr ${id === row.code ? "activeRecord" : ""}`}
                                                >
                                                    <td>
                                                        <Link to={`/departmentstockClosing/${row?.uuid}/${row?.code}`} className={`${id === row.code ? "text-primary" : "text-grey"}`}>
                                                            <span className="titleTr">{row.code}</span>
                                                            <span className="d-flex justify-content-between">
                                                                <span>{row?.createdAt}</span>
                                                            </span>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <div className="text-center" >No Records Found</div>
                                        ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            <div className="column content-column " style={{ left: "301px" }}>
                <div className="header no-border d-flex align-items-center p-4">
                    <div className="listTopHeading d-flex align-items-center">
                        <div className="btn-toolbar over-flow text-muted font-xlarge">
                            <span> {recordDetails.code}</span> &nbsp;&nbsp;
                        </div>
                    </div>
                </div>
                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)} className="upperTabs">
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                    </TabList>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox">
                            <br />
                            <div id="scroll">
                                <div className="font-large text-uppercase font-xs text-open mb-2">{recordDetails.code}</div>
                            </div>
                            <hr />
                            <div className="customTable" id="scroll">
                                {recordDetails && recordDetails.items && recordDetails.items.length !== 0 && (
                                    <div>
                                        <h3 className="font-size-16">ITEMS</h3>
                                        <table className="customTable borderedTable">
                                            <thead>
                                                <tr>
                                                    <td>S No.</td>
                                                    <td>Item</td>
                                                    <td>Updated Box Quantity</td>
                                                    <td>Updated Open Quantity</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {recordDetails.items.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{item.itemTitle}</td>
                                                        <td>{item.updatedBoxQuantity + " " + item.boxQuantityUnit}</td>
                                                        <td>{item.updatedOpenQuantity.toFixed(2) + " " + item.openQuantityUnit}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                <div id="ember3382" className="ember-view"></div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
                            <table>
                                {logData.length === 0 ? (
                                    "No Changes Found"
                                ) : (
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Changes</th>
                                        </tr>
                                    </thead>
                                )}
                                {logData.length >= 1 && (
                                    <tbody>
                                        {logData?.map((history, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td className="mr-2" style={{ verticalAlign: "top", width: "100px" }}>
                                                        {history?.transactionDate?.substring(0, 10)}
                                                        <br />
                                                        Time:
                                                        {history?.transactionDate?.split("T")[1]?.substring(0, 5)}
                                                    </td>
                                                    <td>
                                                        <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </TabPanel>
                </Tabs>
            </div>
            <Toaster />
        </>
    );
};

export default DepartmentStockClosingView;
